<script lang="ts">
    
    import type { Answer } from "../../global";
    import type { Question } from "../../Model/Question";
    import DateString from "../DateString.svelte";
    import Watch from "../Watch.svelte";

    export let question: Question;
    export let answer: Answer;

</script>

<h6>
    <Watch store={question.name} />
</h6>
<p>
    {#if answer?.value}
        <DateString date={answer.value} />
    {:else}
        <i class="text-muted">Sin respuesta</i>
    {/if}
</p>
